// ===========================================
// VirtualizedFileGrid Utilities
// ===========================================
// Helper functions for virtualized file grid

/**
 * Threshold for when to use virtualization
 */
export const VIRTUALIZATION_THRESHOLD = 50;

/**
 * Determine if virtualization should be used based on file count
 */
export function shouldUseVirtualization(fileCount: number): boolean {
  return fileCount >= VIRTUALIZATION_THRESHOLD;
}
